import React from 'react';
import whatsapp from "../assets/socialmedia/whatsapp.png";


export const Newletter = () => {


	const description = "Wenn du neue Releases und Events mitbekommen möchtest, dann tritt gerne meinem WhatsApp-Kanal bei!"

	return (

		<section id='newsletter'>
			<div className='text-card-container'>
				<h1 className='section-header'>Newsletter</h1>


				<div className="row">
					<div className="col">
						{description}
						<br />
						<br />
						<a
							className='nav-bar-link nav-icon'
							href="https://whatsapp.com/channel/0029VbCg9LY1SWsxn6nHmi0v"
							rel="noreferrer"
							target="_blank"
							style={{ display: 'inline-block', textAlign: 'left' }}
						>
							<img className='whatsapp' src={whatsapp} alt="whatsapp" />
						</a>

					</div>
				</div>


			</div>
		</section>

	);
}